<template>
    <div class="flex">
        <Facebook
            :url="`https://www.facebook.com/sharer/sharer.php?u=${encodedURI}`"
            is-large
            is-share-button
            :class="{ 'p-button-light': color === 'white' }"
        />
        <Linkedin
            :url="`http://www.linkedin.com/shareArticle?mini=true&url=${encodedURI}&title=${encodeURIComponent(title)}`"
            is-large
            is-share-button
            class="mx-2"
            :class="{ 'p-button-light': color === 'white' }"
        />
        <Twitter
            :url="`https://twitter.com/intent/tweet?url=${encodedURI}&text=${encodeURIComponent(title)}`"
            is-large
            is-share-button
            :class="{ 'p-button-light': color === 'white' }"
        />
    </div>
</template>

<script>
import Facebook from '@/components/UI/Icons/Facebook';
import Twitter from '@/components/UI/Icons/Twitter';
import Linkedin from '@/components/UI/Icons/Linkedin';

export default {
    name: 'ArticleShareButtonGroup',
    components: {
        Facebook,
        Twitter,
        Linkedin,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        color: {
            type: String,
            required: false,
            default: 'black',
        },
    },
    computed: {
        encodedURI() {
            return encodeURIComponent(this.$config.baseURL + this.$route.path);
        },
    },
};
</script>

<style scoped></style>
